import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fc4b19a4")

_pushScopeId("data-v-fc4b19a4")
const _hoisted_1 = { class: "scrollable-area" }
const _hoisted_2 = { class: "scrollable-area" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titlename,
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = $event)),
    width: "1000px",
    "before-close": _ctx.onCancel
  }, {
    default: _withId(() => [
      _createVNode(_component_el_form, {
        "label-width": "100px",
        "label-position": "right"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "资产公司:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.orgName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "单位证书编号:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.orgCertCode), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "域名:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.hostLocation), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "接口地址:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.api), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 22 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "请求参数:" }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_1, [
                        _createVNode("pre", null, _toDisplayString(_ctx.formatJsonString(_ctx.formdata.param)), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 22 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "错误信息:" }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.formdata.content), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "modelValue", "before-close"]))
})